<template>
  <div class="app-container padding">
    <el-row :gutter="20">
      <!-- 左侧统计类型 -->
      <el-col :span="3">
        <el-card>
          <div class="status-list">
            <div
              v-for="(item, index) in statisticsTypes"
              :key="index"
              class="status-item"
              :class="{ 'status-active': conditions.type === item.type }"
              @click="switchStatisticsType(item)"
            >
              {{ item.name }}
            </div>
          </div>
        </el-card>
      </el-col>

      <!-- 右侧内容 -->
      <el-col :span="21">
        <!-- 筛选条件 -->
        <el-card class="box-card">
          <div slot="header" class="card-header-left">
            <span>{{ $t('statisticsManage.queryConditions') }}</span>
          </div>
          
          <!-- 查询条件 -->
          <el-row :gutter="20" class="condition-row">
            <el-col :xs="24" :sm="12" :md="8" :lg="6" :xl="6">
              <el-date-picker
                v-model="dateRange"
                type="daterange"
                range-separator="至"
                :start-placeholder="$t('statisticsManage.startDate')"
                :end-placeholder="$t('statisticsManage.endDate')"
                value-format="yyyy-MM-dd HH:mm:ss"
                :default-time="['00:00:00', '23:59:59']"
                style="width: 100%"
                @change="handleDateRangeChange"
              />
            </el-col>
            
            <el-col :xs="24" :sm="8" :md="6" :lg="4" :xl="4">
              <el-button type="primary" @click="queryStatistics">{{ $t('statisticsManage.search') }}</el-button>
              <el-button @click="resetStatistics">{{ $t('statisticsManage.reset') }}</el-button>
            </el-col>
          </el-row>
        </el-card>

        <!-- 统计数据展示 -->
        <el-card class="box-card">
          <div slot="header" class="clearfix flex justify-between">
            <span>{{ $t('statisticsManage.statisticsData') }}</span>
          </div>

          <!-- 统计汇总 -->
          <div class="statistics-summary">
            <el-row :gutter="20">
              <el-col :span="12">
                <div class="summary-item">
                  <span class="summary-label">总金额：</span>
                  <span class="summary-value">¥{{ statisticsSummary.orderMoney || 0 }}</span>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="summary-item">
                  <span class="summary-label">总数量：</span>
                  <span class="summary-value">{{ statisticsSummary.orderCount || 0 }}</span>
                </div>
              </el-col>
            </el-row>
          </div>

          <!-- 物资列表 -->
          <el-table v-loading="loading" :data="statisticsData" border style="width: 100%; margin-top: 20px;">
            <el-table-column type="index" label="序号" align="center" width="60" />
            <el-table-column prop="name" label="物资名称" align="center" min-width="150" />
            <el-table-column prop="unit" label="单位" align="center" width="100" />
            <el-table-column prop="num" label="数量" align="center" width="100" />
            <el-table-column prop="price" label="单价" align="center" width="120">
              <template slot-scope="scope">
                <span v-if="scope.row.price">¥{{ scope.row.price }}</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column label="小计" align="center" width="120">
              <template slot-scope="scope">
                <span v-if="scope.row.price && scope.row.num">¥{{ (scope.row.price * scope.row.num).toFixed(2) }}</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { countOrderNum } from '@/api/work/statisticsManageApi'

export default {
  name: 'StatisticsManageList',
  data() {
    return {
      loading: false,
      statisticsTypes: [
        { type: '1', name: '有偿维修统计', orderType: '0' },
        { type: '2', name: '自行修理物资统计', orderType: '1' }
      ],
      conditions: {
        type: '1',
        startTime: '',
        endTime: '',
        orderType: '0'
      },
      dateRange: [],
      statisticsSummary: {
        orderMoney: 0,
        orderCount: 0
      },
      statisticsData: []
    }
  },
  
  mounted() {
    this.initDateRange()
    this.fetchData()
  },
  
  methods: {
    // 初始化日期范围（默认当月）
    initDateRange() {
      const now = new Date()
      const year = now.getFullYear()
      const month = now.getMonth()
      const startDate = new Date(year, month, 1)
      const endDate = new Date(year, month + 1, 0, 23, 59, 59)
      
      this.dateRange = [
        this.formatDate(startDate),
        this.formatDate(endDate)
      ]
      
      this.conditions.startTime = this.dateRange[0]
      this.conditions.endTime = this.dateRange[1]
    },
    
    // 格式化日期
    formatDate(date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    },
    
    // 日期范围变化
    handleDateRangeChange(value) {
      if (value && value.length === 2) {
        this.conditions.startTime = value[0]
        this.conditions.endTime = value[1]
      } else {
        this.conditions.startTime = ''
        this.conditions.endTime = ''
      }
    },
    
    // 切换统计类型
    switchStatisticsType(item) {
      this.conditions.type = item.type
      this.conditions.orderType = item.orderType
      this.fetchData()
    },
    
    // 查询统计数据
    queryStatistics() {
      this.fetchData()
    },
    
    // 重置查询条件
    resetStatistics() {
      this.initDateRange()
      const currentType = this.statisticsTypes.find(t => t.type === this.conditions.type)
      this.conditions.orderType = currentType ? currentType.orderType : '0'
      this.fetchData()
    },
    
    // 获取统计数据
    async fetchData() {
      this.loading = true
      try {
        const params = {
          ...this.conditions
        }
        
        // 过滤空值参数
        Object.keys(params).forEach(key => {
          if (params[key] === '') {
            delete params[key]
          }
        })
        
        const res = await countOrderNum(params)
        
        if (res.data) {
          this.statisticsSummary = {
            orderMoney: res.data.orderMoney || 0,
            orderCount: res.data.orderCount || 0
          }
          this.statisticsData = res.data.materialLists || []
        } else {
          this.statisticsSummary = { orderMoney: 0, orderCount: 0 }
          this.statisticsData = []
        }
      } catch (error) {
        console.log('Failed to fetch statistics:', error)
        this.$message.error(error.message || '获取统计数据失败')
        this.statisticsSummary = { orderMoney: 0, orderCount: 0 }
        this.statisticsData = []
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.app-container {
  padding: 20px;
}

.status-list {
  display: flex;
  flex-direction: column;
}

.status-item {
  padding: 12px 16px;
  cursor: pointer;
  border-bottom: 1px solid #EBEEF5;
  transition: all 0.3s;
  font-size: 13px;
}

.status-item:hover {
  background-color: #F5F7FA;
}

.status-active {
  background-color: #409EFF;
  color: #FFFFFF;
  font-weight: bold;
}

.box-card {
  margin-bottom: 20px;
}

.condition-row {
  display: flex;
  align-items: center;
}

.flex {
  display: flex;
}

.justify-between {
  justify-content: space-between;
}

.card-header-left {
  text-align: left;
}

.statistics-summary {
  padding: 20px;
  background-color: #f5f7fa;
  border-radius: 4px;
}

.summary-item {
  text-align: center;
  padding: 10px;
}

.summary-label {
  font-size: 14px;
  color: #606266;
  margin-right: 8px;
}

.summary-value {
  font-size: 24px;
  font-weight: bold;
  color: #409EFF;
}
</style>

